import { render, staticRenderFns } from "./BrandSaleList.vue?vue&type=template&id=35329477&scoped=true"
import script from "./BrandSaleList.vue?vue&type=script&lang=js"
export * from "./BrandSaleList.vue?vue&type=script&lang=js"
import style0 from "./BrandSaleList.vue?vue&type=style&index=0&id=35329477&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35329477",
  null
  
)

export default component.exports